module.exports = __webpack_public_path__ + "copywriting-2.png?980fb0133997870bd4561b82c0faeb50";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/copywriting-2.png
// module id = 676
// module chunks = 0